$.noConflict();

$(document).ready(function(){

    // Add event listener to quantity input
    $('input[name=quantity]').on('change',function(){
      // Get the quantity value
      const quantity = $(this).val();
      // Define a function to update the price of an element
      function updatePrice(element, value, unit) {
        // Multiply the value by the quantity and round it
        value = Math.round(value * quantity);
        // Divide the value by 100 and format it to two decimals
        value = (value / 100).toFixed(2);
        // Update the element's html with the value and the unit
        element.html(`${unit}${value} <span>inc VAT</span>`);
      }

      function updatePriceEXE(element, value, unit) {
        // Multiply the value by the quantity and round it
        value = Math.round(value * quantity);
        // Divide the value by 100 and format it to two decimals
        value = (value / 100).toFixed(2);
        // Update the element's html with the value and the unit
        element.html(`${unit}${value} <span>exe VAT</span>`);
      }

      
      // Update the selling price element
      updatePrice($('.selling_price'), $('.selling_price').data('selling-price'), '£');
      // Update the selling price main element
      updatePrice($('.selling_price_main'), $('.selling_price_main').data('selling-price-main'), '£');
      // Update the money price element
      updatePriceEXE($('.moneyprice'), $('.moneyprice').data('money-price'), '£');
    });



  
    // Add event listener to card links
    $('.card-link').on('click', function(e){
      // Prevent default behavior of links
      e.preventDefault(); 
      // Get the id of the card
      const cardId = $(this).attr('href');
      // Check if the card is already expanded
      if($(cardId).hasClass('show')){
        // Collapse all cards
        $('.collapse').removeClass('show')
        //console.log('true')
      }else{
        //console.log('false')
        // Collapse all cards
        $('.collapse').removeClass('show')
        // Expand the clicked card
        $(cardId).addClass('show')  
      }
    });
});

